import { Link } from 'react-router-dom';
import { initialOf, t } from '../../i18n';
import { NoteRow } from '../belege/Bell';
import { EMPLOYEE_NOTES } from '../belege/labels';
import { useNotifications } from '../belege/shared';
import { lohnPath } from './labels';

// Teile der Übersicht, die zu Mitarbeitern und Lohn gehören.

// Meldungen zu Mitarbeitern („<Name> ist angemeldet“, „Änderung übernommen“ …) und „Neue Lohnunterlagen“, bis sie
// geöffnet sind (bei mehreren Firmen mit Firmennamen)
export function LohnNotices() {
  const notes = useNotifications();
  const items = (notes.data?.items ?? []).filter((n) => (EMPLOYEE_NOTES.has(n.type) || n.type === 'lohn_unterlagen') && !n.read);
  if (!items.length) return null;
  return (
    <div className="notice" role="status">
      {items.map((n) => (
        <NoteRow key={n.id} item={n} />
      ))}
    </div>
  );
}

// Eintrag in der Liste der Bereiche
export function LohnListItem({ clientId }: { clientId: string }) {
  return (
    <Link className="item" to={lohnPath(clientId)}>
      <span className="ico" aria-hidden="true">
        {initialOf('Mitarbeiter')}
      </span>
      <span className="tx">
        <b>{t('Mitarbeiter')}</b>
        <small>{t('Lohn & Gehalt')}</small>
      </span>
      <span className="chev" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
